import { Injectable, EventEmitter } from '@angular/core';
import { Address } from '../../models/UIModels/Address';

@Injectable({
  providedIn: 'root'
})
export class AddressFormService {

  public AddressListChange : EventEmitter<Array<Address>> = new EventEmitter<Array<Address>>();

  public AddressCreated: EventEmitter<Address> = new EventEmitter<Address>();

  public AddressDeleted: EventEmitter<Address> = new EventEmitter<Address>();

  public CurrentAddressList: Array<Address>;

  constructor() { }

}
